export default "__VITE_ASSET__38b9ba26__"